export default __webpack_public_path__ + "static/transparent-myway-logo~bpcLNEDz-f8a6a8e86754168c1680fa5d62afb311.png";